import { render, staticRenderFns } from "./deviceStatusDataTable.vue?vue&type=template&id=61582dc0&"
import script from "./deviceStatusDataTable.vue?vue&type=script&lang=js&"
export * from "./deviceStatusDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports